import type { ReactNode } from 'react';
import { clsx } from 'clsx';

/**
 * État d'une liste, par priorité : erreur de chargement, « Chargement… », message de liste vide. Sans rien à signaler,
 * affiche ses enfants (la grille de cartes…) ; un tableau le place sans enfant sous ses lignes.
 */
export function ListStatus({
  loading = false,
  error = null,
  empty = false,
  className,
  children,
}: {
  loading?: boolean;
  error?: string | null;
  /** Message de liste vide (false : la liste n'est pas vide) */
  empty?: string | false;
  className?: string;
  children?: ReactNode;
}) {
  if (error) {
    return (
      <p role="alert" className={clsx('text-sm text-destructive whitespace-pre-line', className)}>
        {error}
      </p>
    );
  }
  if (loading) return <p className={clsx('text-sm text-slate-500', className)}>Chargement…</p>;
  if (empty) {
    return (
      <p role="status" className={clsx('text-sm text-slate-500', className)}>
        {empty}
      </p>
    );
  }

  return children;
}
